import React from "react";

export default function Contact() {
  return (
    <section id="contact" className="contact">
      <div className="container">
        <div className="contact-image-container">
          <img src="/image copy.png" alt="Healthcare Professional" className="contact-image" />
        </div>
        <h2 className="section-title">Get In Touch</h2>
        <p className="section-subtitle">
          We're here to answer your questions and schedule your appointment
        </p>
        <div className="contact-content">
          <div className="contact-info">
            <div className="contact-item">
              <h3 className="contact-label">Phone</h3>
              <p className="contact-value">(708) 627-9504</p>
            </div>
            <div className="contact-item">
              <h3 className="contact-label">Email</h3>
              <p className="contact-value">cawondaw@gmail.com</p>
            </div>
            <div className="contact-item">
              <h3 className="contact-label">Hours</h3>
              <p className="contact-value">
                Monday - Friday: 8:00 AM - 5:00 PM<br />
                Saturday: 9:00 AM - 5:00 PM<br />
                Sunday: 9:00 AM - 5:00 PM
              </p>
            </div>
            <div className="contact-item">
              <h3 className="contact-label">Address</h3>
              <p className="contact-value">
                Chicago South Suburb<br />
                Send us an email or give us a call to schedule a tour!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
